var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4724 45.9988H3.46821C2.65655 45.9964 2 45.3374 2 44.5257C2 43.714 2.65651 43.0556 3.46821 43.0531H29.4724C34.3164 43.0477 38.9287 40.9805 42.1559 37.3685C45.3839 33.757 46.9213 28.9419 46.3836 24.1281C45.8465 19.3141 43.2853 14.9562 39.3409 12.1451C35.3964 9.33351 30.4415 8.33429 25.7159 9.39737C20.9897 10.4599 16.9398 13.4842 14.5789 17.7139C12.2175 21.9432 11.7688 26.9776 13.3439 31.5588C13.4991 32.0086 13.4269 32.506 13.1505 32.8934C12.8745 33.2813 12.4277 33.5111 11.9514 33.5111H8.11101C7.29737 33.5111 6.6384 32.8517 6.6384 32.0385C6.6384 31.2249 7.29736 30.5654 8.11101 30.5654H9.99605C9.64694 29.0688 9.47114 27.5362 9.47212 25.9994C9.47212 14.9714 18.4442 6 29.4727 6C40.5007 6 49.4721 14.9716 49.4721 25.9994C49.4721 37.0272 40.5006 46 29.4727 46L29.4724 45.9988Z",
    fill: "#333333",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2881 28.1024H29.4731C29.0822 28.1024 28.7076 27.9473 28.4316 27.6708C28.1552 27.3949 28 27.0202 28 26.6293V17.4849C28 16.6713 28.6595 16.0123 29.4731 16.0123C30.2863 16.0123 30.9457 16.6713 30.9457 17.4849V25.1567H36.2881C37.1017 25.1567 37.7607 25.8162 37.7607 26.6293C37.7607 27.443 37.1018 28.1025 36.2881 28.1025L36.2881 28.1024Z",
    fill: "#333333",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8293 40.0204H4.53195C3.71831 40.0204 3.05884 39.361 3.05884 38.5473C3.05884 37.7342 3.71829 37.0747 4.53195 37.0747H14.8293C15.6425 37.0747 16.3019 37.7342 16.3019 38.5473C16.3019 39.361 15.6425 40.0204 14.8293 40.0204Z",
    fill: "#333333",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickIco);
export default __webpack_public_path__ + "static/media/quickIco.0bf5f78d5d36e037be87cca3abd0409b.svg";
export { ForwardRef as ReactComponent };